
import React, { Suspense } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Dashboard from "./pages/admin/Dashboard";
import CampaignsList from "./pages/admin/CampaignsList";
import CreateCampaign from "./pages/admin/CreateCampaign";
import EditCampaign from "./pages/admin/EditCampaign";
import VouchersList from "./pages/admin/VouchersList";
import Settings from "./pages/admin/Settings";
import NotFound from "./pages/NotFound";
import { Toaster } from "sonner";
import AddVenue from "./pages/admin/AddVenue";
import { AuthProvider } from "./context/AuthContext";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            {/* User-facing routes */}
            <Route path="/" element={<Index />} />
            <Route path="/auth" element={<Auth />} />
            
            {/* Admin routes */}
            <Route path="/admin/dashboard" element={<Dashboard />} />
            <Route path="/admin/campaigns" element={<CampaignsList />} />
            <Route path="/admin/campaigns/new" element={<CreateCampaign />} />
            <Route path="/admin/campaigns/:id" element={<EditCampaign />} />
            <Route path="/admin/campaigns/edit/:id" element={<EditCampaign />} />
            <Route path="/admin/venues/add" element={<AddVenue />} />
            <Route path="/admin/vouchers" element={<VouchersList />} />
            <Route path="/admin/settings" element={<Settings />} />
            
            {/* 404 route */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Toaster richColors />
        </Suspense>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
